module.exports = __webpack_public_path__ + "img/4.bc0cd5ad.jpg";